import axios from 'axios';
import { BASE_CLOUD_ADDR } from '../Constants/BaseURL';

const axiosInstance = axios.create({
  baseURL: BASE_CLOUD_ADDR,
  timeout: 120000
})
// axios.defaults.baseURL = 'http://localhost:8000';

axiosInstance.interceptors.request.use(function (config:any) {
  // Do something before request is sent
  config.headers.post['Content-Type'] = 'application/json';
  config.headers.common.Accept = 'application/json';
  config.headers.post['Access-Control-Allow-Origin'] = "*";
  // config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  // config.headers.Pragma = 'no-cache';
  // config.headers.Expires = '0';
  // config.params = { ...config.params, _t: Date.now() };
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(function (response) {
  response.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  response.headers.Pragma = 'no-cache';
  response.headers.Expires = '0';
  return response;
}, function (error) {
  return Promise.reject(error);
});

const bucketService = {
  lgaService: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/lga.json`);
  },
  stateService: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/state.json`);
  },
  subjectService: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/subject.json`);
  },
  waecService: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/waec.json`);
  },
  countryService: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/country.json`);
  },
  faq: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/faq.json`);
  },
  statusInfo: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/status-info.json`);
  },
  admissionSetting: async () => {
    return await axiosInstance.get(`assets/table-memory-storage/dataset/admission-settings.json`);
  }
}
export default bucketService
